import { customElement, property } from "lit/decorators.js";
import { html, LitElement } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

@customElement("base-component")
export class BaseComponent extends LitElement {
  readonly componentPrefix: string = "euk-search:";

  @property({ type: Array<string> })
  stylesheets: string[] = [];

  @property({ type: String })
  componentid: string = "web-component";

  constructor() {
    super();
  }

  getEventName(eventName: string) {
    return `${this.componentPrefix}${this.getComponentPrefixId()}${eventName}`;
  }

  private getComponentPrefixId() {
    return this.componentid && this.componentid != "" ? `${this.componentid}-` : "";
  }

  triggerEvent<T>(detailObject: T, eventName: string) {
    const options = {
      detail: detailObject,
      bubbles: true,
      composed: true,
    };
    const name = this.getEventName(eventName);
    this.dispatchEvent(new CustomEvent<T>(name, options));
    this.requestUpdate();
  }

  addListener<T>(eventName: string, fallback: (e: CustomEvent<T>) => Promise<void>) {
    window.addEventListener(this.getEventName(eventName), async e => fallback(e as CustomEvent<T>), { passive: true });
  }

  render() {
    return this.stylesheets && this.stylesheets.length > 0
      ? html`
        <style>
          ${Object.entries(this.stylesheets ?? []).map(([, stylesheet]) => {
            return html`
              ${unsafeHTML("@import \"" + stylesheet + "\"")};
            `;
          })}
        </style>
      `
      : html``;
  }
}
